export default __webpack_public_path__ + "static/media/nav-groceries-white.16274756.svg";